<template>
  <div class="milestone-navigation">
    <Grid class="round-icons-wrapper">
      <Grid gaf="column" align-items="center">
        <DotArrow class="flip-horizontal" />
        <DotArrow />
      </Grid>

      <Grid gtc="repeat(11, 1fr)" class="round-items q-px-md" place-items="center">
        <RoundCmp
          v-for="(milestone, index) of milestones"
          :key="milestone.id"
          :loading="loading"
          :label-bottom="index % 2 !== 0"
          :active="selectedMilestoneMarker === index"
          :milestone="milestone"
          @click="$emit('select-milestone', { event: milestone, index })"
        />
      </Grid>
    </Grid>
  </div>
</template>

<script>
// Libraries
import { mapState } from 'vuex'
import { get } from 'lodash'
// Components
import DotArrow from '@/reusable/svg-icons/DotArrow'
import RoundCmp from './RoundCmp'

export default {
  components: {
    DotArrow,
    RoundCmp
  },

  props: {
    loading: Boolean,
    selectedMilestoneMarker: {
      type: Number,
      required: true
    }
  },

  computed: {
    ...mapState('subscriptions/subscriptionPeriods', {
      milestonesMeta: state => state.milestonesMeta
    }),

    milestones() {
      return get(this.milestonesMeta, 'milestones_with_status')
    }
  },

  watch: {
    'milestonesMeta.id'(newVal, oldVal) {
      if (!newVal || newVal === oldVal) return
      this.$emit('change-period', newVal)
    }
  }
}
</script>

<style lang="scss" scoped>
.round-icons-wrapper {
  isolation: isolate;

  > * {
    grid-area: 1 / -1;
  }

  .round-items {
    z-index: 1;
  }
}
</style>
